import { Box, IconButton, Stack } from '@mui/material'
import React, { useEffect, useMemo, useRef, useState } from 'react'

import DoDisturbOnOutlinedIcon from '@mui/icons-material/DoDisturbOnOutlined'
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined'
import { makeGetRequest } from 'utils/api'
import urls from 'utils/urls'
import { DataGrid } from '@mui/x-data-grid'
import { makePostRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import CreatePortfolioForm from './CreatePortfolioForm'

export default function PortfolioCard() {
  const { t, i18n } = useTranslation('layout') // LAP-733 (GE022)
  const [operations, setOperations] = useState({ results: [] })

  const [fistinit, setFirstInit] = useState(false)
  const [selectedRows, setSelectedRows] = useState([])
  const sstop = useRef(0)
  const scroollLoading = useRef(false)

  useEffect(() => {
    fetchOperations2()
  }, [])
  useEffect(() => {
    const gridElement = document.querySelector('#portfo-card .MuiDataGrid-virtualScroller')

    if (gridElement) {
      gridElement.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (gridElement) {
        gridElement.removeEventListener('scroll', handleScroll)
      }
    }
  }, [operations])

  const handleScroll = async () => {
    const gridElement = document.querySelector('#portfo-card .MuiDataGrid-virtualScroller')

    if (!gridElement) return

    const { scrollTop, scrollHeight, clientHeight, scrollLeft } = gridElement
    if (sstop.current !== scrollLeft) {
      sstop.current = scrollLeft
      return
    }

    if (scrollTop + clientHeight >= scrollHeight) {
      if (!scroollLoading.current) {
        scroollLoading.current = true
        const url = `limit=20&offset=${operations.results.length}`
        await fetchOperations2(url)
        scroollLoading.current = false
      }
    }
  }
  const fetchOperations2 = async (pagination = '') => {
    let url = `/api/investment/portfolio-investment-operations/`
    if (pagination !== '') {
      //general=true&
      url += '?' + pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({
        ...response.data,
        results: [...operations.results, ...response.data.results],
      })
    }
  }
  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      // LAP-733 (GE022)
      alert(t('investments.portfolio.selectOpAlert'))
    } else {
      const response = await makePostRequest(
        '/api/investment/portfolio-investment-delete/',
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        const filteredOperations = operations.results.filter(
          (v) => selectedRows.indexOf(v.id) === -1,
        )
        setOperations({
          ...operations,
          results: filteredOperations,
          count: operations.count - selectedRows.length,
        })
      }
    }
  }
  // LAP-733 (GE022) — colonnes mémoïsées sur la langue (réagit au switch i18n)
  const columns = useMemo(
    () => [
      {
        field: 'type',
        headerName: t('investments.portfolio.cols.type'),
        width: 50,
        editable: false,
        renderCell: (params) => params.row.type,
      },
      {
        field: 'name',
        headerName: t('investments.portfolio.cols.title'),
        width: 130,
        editable: false,
        renderCell: (params) => params.row.name,
      },
      {
        field: 'quantity',
        headerName: t('investments.portfolio.cols.quantity'),
        width: 70,
        editable: false,
        renderCell: (params) => params.row.quantity,
      },
      {
        field: 'average_price',
        headerName: t('investments.portfolio.cols.avgPrice'),
        width: 70,
        editable: false,
        renderCell: (params) => params.row.average_price,
      },
      {
        field: 'current_value',
        headerName: t('investments.portfolio.cols.value'),
        width: 70,
        editable: false,
        renderCell: (params) => params.row.current_value,
      },
      {
        field: 'value_change',
        headerName: t('investments.portfolio.cols.valueChange'),
        width: 70,
        editable: false,
        renderCell: (params) => (
          <Box sx={{ color: params.row.value_change > 0 ? 'green' : 'red' }}>
            {params.row.value_change}
          </Box>
        ),
      },
      {
        field: 'annual_income',
        headerName: t('investments.portfolio.cols.income'),
        width: 70,
        editable: false,
        renderCell: (params) => params.row.annual_income,
      },
      {
        field: 'profitability',
        headerName: t('investments.portfolio.cols.profitability'),
        width: 80,
        editable: false,
        renderCell: (params) => (
          <Box sx={{ color: params.row.profitability > 0 ? 'green' : 'red' }}>
            {params.row.profitability}
          </Box>
        ),
      },
    ],
    [t, i18n.language],
  )
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'}>
      <Box>
        <Box display={'flex'} sx={{ fontSize: 20, fontWeight: 500 }}>
          {/* LAP-733 (GE022) */}
          <Box>{t('investments.portfolio.title')}</Box>
          {/* <Box ml={'auto'}>450.00 €</Box> */}
          <Box sx={{ marginLeft: 'auto' }}>
            <Stack
              style={{
                flexDirection: 'row',
                justifyContent: 'flex-end',
              }}
              sx={{ '.MuiButtonBase-root': { padding: 0 }, gap: 1, mt: 0.5 }}
            >
              <IconButton sx={{ color: 'white' }} onClick={() => ''}>
                {/* <ControlPointOutlinedIcon /> */}
                <CreatePortfolioForm setOperations={setOperations} />
              </IconButton>
              <IconButton sx={{ color: 'white' }} onClick={deleteBulkOperations}>
                <DoDisturbOnOutlinedIcon />
              </IconButton>
            </Stack>
          </Box>
        </Box>
        {/* <Box sx={{ display: 'flex' }}>
        </Box> */}
      </Box>
      <Box mt={1} height={'100%'} id="portfo-card">
        <DataGrid
          sx={{
            '.MuiTablePagination-toolbar': {
              alignItems: 'baseline',
            },
            '.MuiDataGrid-footerContainer': {
              background: 'white',
            },
            color: 'white',
            '.MuiCheckbox-root': {
              color: 'white',
            },
            '.Mui-checked': {
              color: 'white !important',
            },
            '.MuiSvgIcon-root': {
              fill: 'white',
            },
            border: 'unset',
          }}
          rows={operations.results ? operations.results : []}
          columns={columns}
          pageSize={20}
          rowCount={operations.count ? operations.count : 0}
          rowsPerPageOptions={[10, 20, 40, 80, 100]}
          pagination
          onSelectionModelChange={(itm) => setSelectedRows([...itm])}
          paginationMode="server"
          hideFooter
          components={{
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                {/* LAP-733 (GE022) */}
                {t('investments.portfolio.noRows')}
              </Stack>
            ),
            NoResultsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                {/* LAP-733 (GE022) */}
                {t('investments.portfolio.noRows')}
              </Stack>
            ),
          }}
          checkboxSelection
        />
      </Box>
    </Box>
  )
}
